import { apiSlice } from '@/shared/api/apiSlice'
import { ServerResponse } from '@/shared/types/common'

import { CatalogBannerConfig } from '../types/types'

type GetCatalogBannersRequest = {
	mainCategory: string
	childCategory: string
}

export const catalogBannerApiSlice = apiSlice.injectEndpoints({
	endpoints: build => ({
		getCatalogBanners: build.query<CatalogBannerConfig | null, GetCatalogBannersRequest>({
			query: ({ mainCategory, childCategory }) => ({
				url: `category/banner`,
				params: {
					...(mainCategory && { CATEGORY: mainCategory }),
					...(childCategory && { CHILD_CATEGORY: childCategory })
				}
			}),
			transformResponse: (res: ServerResponse<CatalogBannerConfig>): CatalogBannerConfig => {
				// const result = CatalogBannerConfigSchema.safeParse(res?.data)
				return res?.data
				// if (result.success) return res?.data
				// else return null
			}
		})
	})
})
